<template>
  <div class="w1200" style="text-align: center">
    <div class="contentBox" :style="'background-image:url('+banner_big+')'" />
    <div class="gohome">
      <span>{{ item }}</span>秒后返回首页
    </div>
  </div>
</template>

<script>
export default {
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '',
      mateDesc: metaStr,
      keys: ' '
    }
  },
  name: '404',
  data() {
    return {
      banner_big: require('@/static/404code.jpg'),
      item: 10,
      timer: null
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.item--
      if (this.item <= 0) {
        this.$router.replace('/home')
        clearInterval(this.timer)
      }
    }, 1000)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .gohome{
    padding-bottom: 200px;
    margin-top: 20px;
    color: #ccc;
    font-size: 20px;
    span{
      color: cornflowerblue;
      font-size: 20px;
     }
  }
  .contentBox{
         margin-top: 200px;
         display: inline-block;
         width: 457px;
         height: 220px;
         font-size: 0;
         background-position: center center;
         background-size: auto 100%;
       }
</style>
